export const products = [
	{
		title: 'Kôdè #batuku $K001 - [Black] T-Shirt',
		image: '../images/assets/small/k01.jpg',
		size: 'S – 2XL',
		color: 'black',
		desc:"Short sleeves T-Shirt in black with “Kôdè™”logo printed at front and image of batukaderas along with text in white. Oversize fitting",
		product: 'Shirt',
		amount: '50',
		id: 'batuku',
		material: '100% Cotton'
	},
	{
		title: 'Kôdè #panu - $K002 - [Black] T-Shirt',
		image: '../images/assets/small/k02.jpg',
		size: 'Size: S – 2XL',
		desc:"Short sleeves T-Shirt in black with “Kôdè™” logo printed at front and #panu di terra geometric pattern in white and spots of green at the back. Oversize fitting",
		color: 'black',
		product: 'Shirt',
		amount: '50',
		id: 'panu',
		material: '100% Cotton'
	},
	{
		title: 'Kôdè c/o Endless #collab  - $K003 - [Black] T-Shirt',
		image: '../images/assets/small/k03.jpg',
		amount: '50',
		desc:"Short sleeves T-Shirt in with creative art by Endless along with “Kôdè™” Logo. Oversize fitting",
		size: 'Size: S – 2XL',
		color: 'black',
		product: 'Shirt',
		id: 'Collab',
		material: '100% Cotton'
	},
	{
		title: 'Kôdè x SWAGG #socialmoney - $K004 - [Black] T-Shirt',
		image: '../images/assets/small/k04.jpg',
		amount: '50',
		size: 'Size: S – 2XL',
		desc:"Short sleeves T-Shirt in black with “Kôdè™”logo printed at front and SWAGG logo in green at back. Oversize fitting",
		color: 'black',
		product: 'Shirt',
		id: 'socialmoney',
		material: '100% Cotton'
	},

	{
		title: 'Kôdè #reflections - $K006 - [Black] T-Shirt',
		image: '../images/assets/small/k05.jpg',
		amount: '50',
		size: 'Size: S – 2XL',
		color: 'black',
		desc:"Short sleeves T-Shirt in with line patterns at the back and “Kode”TM Logo. Oversize fitting",
		product: 'Shirt',
		id: 'reflections',
		material: '100% Cotton'
	},
	{
		title: 'Kôdè #tributemoney- $K005 - [Black] T-Shirt',
		image: '../images/assets/small/k06.jpg',
		amount: '50',
		desc:"Short sleeves T-Shirt in with a scene depicted in The Tribute Money at back featuring white text and “Kôdè™”logo. Oversize fitting",
		size: 'Size: S – 2XL',
		color: 'black',
		product: 'Shirt',
		id: 'tributemoney',
		material: '100% Cotton'
	}
];
